module.exports = __webpack_public_path__ + "media/images/smart_phone/topic_3-fe8f1d1637a12663e3a4d207f6212611.png";